import React from 'react'
import { Show, TextField, DateField } from '@refinedev/antd'
import { useShow } from '@refinedev/core'
import { Typography, List as AntList, Divider } from 'antd'
import type { Tables } from '@muaa/shared'

type Devotional = Tables<'devotionals'>

const { Title } = Typography

export function DevotionalShow() {
  const { query } = useShow<Devotional>()
  const isLoading = query.isLoading
  const record = query.data?.data

  return (
    <Show isLoading={isLoading}>
      {/* ── Header ─────────────────────────────────────────── */}
      <Divider orientation="left">Header</Divider>
      <Title level={5}>Date</Title>
      <TextField value={record?.date ?? '—'} />
      <Title level={5}>Title</Title>
      <TextField value={record?.title ?? '—'} />

      {/* ── Scripture ──────────────────────────────────────── */}
      <Divider orientation="left">Scripture</Divider>
      <Title level={5}>Reference</Title>
      <TextField value={record?.ref ?? '—'} />
      <Title level={5}>Verse</Title>
      <TextField value={record?.verse ?? '—'} />

      {/* ── Reflection ─────────────────────────────────────── */}
      <Divider orientation="left">Reflection</Divider>
      <Title level={5}>Body</Title>
      {Array.isArray(record?.body) && record.body.length > 0 ? (
        <AntList
          dataSource={record.body}
          renderItem={(paragraph: string, index: number) => (
            <AntList.Item key={index} style={{ display: 'block', paddingBottom: 8 }}>
              <Typography.Paragraph style={{ marginBottom: 0 }}>{paragraph}</Typography.Paragraph>
            </AntList.Item>
          )}
          size="small"
          split={false}
        />
      ) : (
        <TextField value="—" />
      )}

      {/* ── Prayer ─────────────────────────────────────────── */}
      <Divider orientation="left">Prayer</Divider>
      <Title level={5}>Prayer</Title>
      <TextField value={record?.prayer ?? '—'} />

      <Divider />
      <Title level={5}>Created</Title>
      {record?.created_at ? (
        <DateField value={record.created_at} format="MMM D, YYYY h:mm A" />
      ) : (
        <TextField value="—" />
      )}
    </Show>
  )
}
